// ** Third Party Imports
import styled from 'styled-components'

// ** Component Imports
import { Heading, Typography, Dialog } from '@/shared/ui'

export const StyledDialogContent = styled(Dialog.Content)`
	max-width: 30rem;
	z-index: 1000;
	text-align: center;
	padding: 2.5rem 2rem;

	& > button {
		// remove close butotn
		display: none;
	}
`

export const StyledHeading = styled(Heading)`
	color: ${({ theme }) => theme.pallette.text.black75};
	margin-bottom: 2rem;
`

export const StyledTypography = styled(Typography)`
	color: ${({ theme }) => theme.pallette.text.black75};
	margin-bottom: 2rem;
`

export const StyledDialogShareContent = styled(Dialog.Content)`
	max-width: 42rem;
`

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 2rem;
	margin-bottom: 1rem;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;

	& > button {
		width: 100%;
	}
`
